import { beforeSend as frontendWpCorptoolsPlugin } from './frontend-wp-corptools-plugin.js';

const filters = [
  frontendWpCorptoolsPlugin,
];

// Run every registered integration filter in order; the first to return null
// drops the event so it never reaches the global Sentry project.
export function beforeSend(event, hint) {
  for (const filter of filters) {
    const result = filter(event, hint);
    if (result === null) return null;
    event = result;
  }
  return event;
}
